// @owners { team: patients }
import { type DataSource } from '@alto/design-system/src/components/inputs/src/InputAutocomplete/types';
import { isAltoPharmacy } from '~shared/helpers/isAltoPharmacy';
import {
  type GooglePlacesValue,
  googlePlacesEstablishmentDataSource,
} from '../../../address/components/data-source/googlePlacesDataSource';

/**
 * Pharmacy search for inbound transfers. Alto locations are excluded so patients
 * cannot select Alto as the transferring pharmacy.
 */
export const transferPharmacyDataSource: DataSource<GooglePlacesValue> = async (text) => {
  const results = await googlePlacesEstablishmentDataSource(text);
  return results.filter((row) => !isAltoPharmacy(row.title));
};
